import {omit} from 'ramda';
import {isNotNilOrEmpty} from 'ramda-adjunct';

import {GetServiceOrderJobItemWorkApiResponse} from '@dms/api/workshop';
import {getDecimalFromPercentage} from '@dms/shared';

import {Nullish} from 'shared/web';

import {EditLabourItemFormType} from '../components/EditLabourItem/types/editLabourItemFormSchema';

const MANUAL_DISCOUNT_SOURCE_TYPE = 'manual-discount';

/**
 * Maps the edit-item form values into the request body accepted by
 * `usePatchOrderItemForWorkMutation`. Discount source/rate are resolved from
 * the originally loaded item so the selected discount type stays consistent.
 */
export const getPatchOrderItemWorkBody = (
  data: EditLabourItemFormType,
  itemData: GetServiceOrderJobItemWorkApiResponse | Nullish
) => {
  const matchedDiscount = itemData?.discount?.availableDiscounts?.find(
    (discount) => discount?.sourceType === data.discountType
  );

  const discountRate =
    data.discountType === MANUAL_DISCOUNT_SOURCE_TYPE
      ? getDecimalFromPercentage(data.discountRate)
      : matchedDiscount?.rate;

  return {
    name: data.name ?? '',
    number: data.number,
    workType: data.workType ?? '',
    labourRateId: data.labourRateId ?? '',
    quantity: data.quantity ?? 0,
    sellingPricePerUnit: data.sellingPricePerUnit ?? 0,
    purchasePricePerUnit: data.purchasePricePerUnit ?? 0,
    isCustomPrice: data.isCustomPrice ?? false,
    sellingPriceVat: {
      freeCode: data.vatFreeCode,
      type: data.vatType,
    },
    workItemGroupId: data.workItemGroupId,
    timeOutputPerUnit: data.timeOutputPerUnit,
    isUnitPriceWithVat: itemData?.isUnitPriceWithVat ?? false,
    priceType: itemData?.priceType ?? null,
    isDiscount: !!data.isCustomDiscount,
    isDoNotApplyDiscount: !!data.isDoNotApplyDiscount,
    discount: data.isCustomDiscount
      ? {
          sourceType: data.discountType ?? '',
          source: matchedDiscount?.source,
          rate: discountRate ?? 0,
        }
      : null,
    assignMechanics: data.assignMechanics
      ?.filter((mechanic) => isNotNilOrEmpty(mechanic?.id))
      .map((mechanic, index) => ({
        ...omit(['ratio'], mechanic),
        id: mechanic.id ?? '',
        isDefault: index === 0,
        amount: mechanic?.amount ?? 0,
        ratio: getDecimalFromPercentage(mechanic?.ratio) ?? 0,
      })),
  };
};
